export function buildWhatsAppUrl(phone: string, message: string): string {
  const normalizedPhone = phone.replace(/\D/g, "");
  return `https://wa.me/${normalizedPhone}?text=${encodeURIComponent(message)}`;
}

export function buildListingWhatsAppMessage({
  title,
  merchantName,
  priceAed,
  listingUrl,
}: {
  title: string;
  merchantName: string;
  priceAed?: number | null;
  listingUrl: string;
}): string {
  return [
    `Hi, I found this listing from ${merchantName} on Souq Crypto and would like to know more.`,
    `Listing: ${title}`,
    priceAed != null ? `Price: AED ${priceAed.toLocaleString()}` : "",
    `Listing: ${listingUrl}`,
    "Source: Souq Crypto",
  ].filter(Boolean).join("\n");
}

export function buildMerchantWhatsAppMessage({
  merchantName,
  merchantUrl,
}: {
  merchantName: string;
  merchantUrl: string;
}): string {
  return [
    `Hi, I found ${merchantName} on Souq Crypto and would like to know more about your business.`,
    `Business profile: ${merchantUrl}`,
    "Source: Souq Crypto",
  ].join("\n");
}